import React, { useState, useEffect, useRef } from 'react';
import './ScrollToTopButton.css';
import { FaChevronUp, FaChevronDown } from 'react-icons/fa';

const ScrollToTopButton = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [isScrollingUp, setIsScrollingUp] = useState(true);
  const lastScrollY = useRef(0);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      const windowHeight = window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight;
  
      if (currentScrollY > 300) {
        setIsVisible(true);
  
        // Check if user reached the bottom
        if (windowHeight + currentScrollY >= documentHeight - 10) {
          setIsScrollingUp(true);
        } else {
          setIsScrollingUp(currentScrollY < lastScrollY.current);
        }
      } else {
        setIsVisible(false);
      }
  
      lastScrollY.current = currentScrollY;
    };
  
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  

  const handleClick = () => {
    window.scrollTo({
      top: isScrollingUp ? 0 : document.body.scrollHeight,
      behavior: 'smooth',
    });
  };

  return (
    isVisible && (
      <div className="scroll-to-top" onClick={handleClick}>
        {isScrollingUp ? (
          <FaChevronUp className="scroll-icon" />
        ) : (
          <FaChevronDown className="scroll-icon" />
        )}
      </div>
    )
  );
};

export default ScrollToTopButton;
